import { CogsCards } from '@/feature/financial-model/ecommerce/cogs/components/CogsCards'

const CogsForecastRoute = () => <CogsCards tab='forecast' />

export default CogsForecastRoute
